module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5a70df361bb00fa62b9338d89c92f377.png";